var React = require('react');

function MapPinUncolored (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.209 0C11.24 0 5.83398 4.96271 5.83398 11.0863C5.83398 17.2083 10.7665 24.5175 17.209 35C23.6515 24.5175 28.584 17.2083 28.584 11.0863C28.584 4.96271 23.1794 0 17.209 0ZM17.209 16.0417C14.8529 16.0417 12.9434 14.0831 12.9434 11.6667C12.9434 9.25021 14.8529 7.29167 17.209 7.29167C19.565 7.29167 21.4746 9.25021 21.4746 11.6667C21.4746 14.0831 19.565 16.0417 17.209 16.0417Z"}));
}

MapPinUncolored.defaultProps = {"height":"35","viewBox":"0 0 35 35","fill":"currentColor"};

module.exports = MapPinUncolored;

MapPinUncolored.default = MapPinUncolored;
